import React, { useState, useEffect } from 'react';
import { Card, Modal, Button } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from "../../../api/api";
import DOMPurify from "quill/formats/link";

function CardLayout({ value, tablaComponent }) {
    const [data, setData] = useState(null);
    const [modalContent, setModalContent] = useState({ show: false, title: '', body: '' });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get(`/detailoption/option/value/${value}`);
                setData(response.data.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [value]);

    const openModal = (title, body) => setModalContent({ show: true, title, body });
    const closeModal = () => setModalContent({ show: false, title: '', body: '' });

    if (!data) {
        return <div>Cargando...</div>;
    }

    return (
        <div>
            {data.map((item) => (
                <Card key={item.id}>
                    <Card.Body style={{ overflowX: 'auto' }}>
                        <Card.Title className="d-flex align-items-center gap-2">
                            <span>{item.value}</span>

                            {/* Botón ℹ️ para el tooltip */}
                            {item.tooltip && (
                                <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 text-info"
                                    onClick={() => openModal(item.value, DOMPurify.sanitize(item.tooltip))}
                                    title="Ver información"
                                >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </Button>
                            )}

                            {/* Botón "Más información" para el modal de detalle */}
                            {item.modal && (
                                <Button
                                    variant="link"
                                    size="sm"
                                    onClick={() => openModal(item.value, DOMPurify.sanitize(item.modal))}
                                    style={{ marginLeft: '4px' }}
                                >
                                    Más información
                                </Button>
                            )}
                        </Card.Title>

                        {item.link && (
                            <Card.Link href={item.link} target="_blank">
                                Enlace
                            </Card.Link>
                        )}
                        {item.description && (
                            <div dangerouslySetInnerHTML={{ __html: item.description }} />
                        )}
                        {tablaComponent}
                    </Card.Body>
                </Card>
            ))}

            {/* Modal compartido */}
            <Modal show={modalContent.show} onHide={closeModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{modalContent.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={{ __html: modalContent.body }} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CardLayout;